import { useQuery } from '@tanstack/react-query';
import { api } from './api';

/** Public event settings, shared by every page. */
export function useSettings() {
  return useQuery({
    queryKey: ['settings', 'public'],
    queryFn: ({ signal }) => api.settings.public(signal),
    staleTime: 60_000,
  });
}
